import { render } from "./DoughnutDisplay.vue?vue&type=template&id=656e4d65&scoped=true"
import script from "./DoughnutDisplay.vue?vue&type=script&lang=js"
export * from "./DoughnutDisplay.vue?vue&type=script&lang=js"

import "./DoughnutDisplay.vue?vue&type=style&index=0&id=656e4d65&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Keith\\Dropbox\\WebStorm\\Projects\\slumbernot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656e4d65"]])

export default __exports__